var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80.73 58.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#84aff1;}.cls-2{fill:#3865ab;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.11,
    y1: 33.93,
    x2: 72.49,
    y2: 33.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.14,48.88l7-13.94v-.11H26v-3.4H38.54v3.43l-7.06,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.2,31.13a8.09,8.09,0,0,1,2.74.47,6.1,6.1,0,0,1,2.32,1.48,7,7,0,0,1,1.61,2.67,12,12,0,0,1,.59,4,12.44,12.44,0,0,1-.91,5A7.32,7.32,0,0,1,51,48a6.77,6.77,0,0,1-3.87,1.11,7,7,0,0,1-3.25-.71,5.91,5.91,0,0,1-2.24-1.92,5.79,5.79,0,0,1-1-2.71h4.15a2.07,2.07,0,0,0,.83,1.31,2.77,2.77,0,0,0,3.9-1,7.76,7.76,0,0,0,.79-3.78h-.1a3.94,3.94,0,0,1-1.75,1.84,5.41,5.41,0,0,1-2.68.67A5.32,5.32,0,0,1,43,42.15a5,5,0,0,1-1.88-2,5.89,5.89,0,0,1-.68-2.88,6,6,0,0,1,.85-3.21,5.85,5.85,0,0,1,2.37-2.17A7.45,7.45,0,0,1,47.2,31.13Zm0,3.24a2.59,2.59,0,0,0-1.94.8,3,3,0,0,0,0,4,2.73,2.73,0,0,0,3.86,0,2.79,2.79,0,0,0,.78-2,2.82,2.82,0,0,0-.77-2A2.56,2.56,0,0,0,47.23,34.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.08,18.55a24.24,24.24,0,0,1,8.28-2.22v-8a31.86,31.86,0,0,0-12.29,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.36,8.31v8a24.23,24.23,0,0,1,8.29,2.22l4-6.94A31.86,31.86,0,0,0,42.36,8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.52,56a36.13,36.13,0,0,1-3.44-18A36.37,36.37,0,1,1,73.21,56a1,1,0,0,0,.39,1.3l1.75,1a1,1,0,0,0,1.4-.42A40.37,40.37,0,1,0,4,57.83a1,1,0,0,0,1.4.42l1.75-1A1,1,0,0,0,7.52,56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.77,51.1a1,1,0,0,0,.41-1.27,24.08,24.08,0,0,1,8.44-29.27l-4-6.94A32.06,32.06,0,0,0,11.14,53.68a1,1,0,0,0,1.41.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.49,40.37a24.09,24.09,0,0,1-1.94,9.46A1,1,0,0,0,63,51.1l5.22,3a1,1,0,0,0,1.41-.43A32.06,32.06,0,0,0,58.12,13.62l-4,6.94A24.12,24.12,0,0,1,64.49,40.37Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGauge);
export default __webpack_public_path__ + "static/media/icon_gauge.93a6bf5ccdfd082c5a4d1e2435f51f69.svg";
export { ForwardRef as ReactComponent };